import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["field", "input", "tierRow"]

  connect() {
    this.requireAtLeastOne()
    this.syncTierRows()
  }

  onInputChange(e) {
    this.requireAtLeastOne()
    this.syncTierRows()
  }

  requireAtLeastOne() {
    const areAllInputsBlank = this.inputTargets.every((i) => !i.value)

    this.fieldTargets.forEach((f) => {
      const input = f.querySelector("input:not([type='hidden']), select")
      const label = f.querySelector("label")

      if (!input || !label) {
        return
      }

      let asterisk = label.querySelector("[data-required-asterisk]")
      if (!asterisk) {
        asterisk = label.appendChild(document.createElement("span"))
        asterisk.setAttribute("data-required-asterisk", "")
        asterisk.textContent = "*"
      }

      asterisk.hidden = !areAllInputsBlank
      input.toggleAttribute("required", areAllInputsBlank)
    })
  }

  showAll(e) {
    e.currentTarget.classList.add("hidden")

    this.fieldTargets.forEach((t) => {
      t.classList.remove("hidden")
    })
  }

  // Better/Best rows mirror the billing intervals that have a Good base price.
  syncTierRows() {
    this.tierRowTargets.forEach((row) => {
      const goodInput = this.inputTargets.find(
        (input) => input.dataset.billingIntervalId === row.dataset.billingIntervalId
      )

      row.hidden = !goodInput || !goodInput.value
    })
  }
}
